import { useState, useEffect } from 'react';
import './Reports.css';

import banner from './images/banner.jpg';
import hjb01 from './images/hjb_01.jpg';
import hjb02 from './images/hjb_02.jpg';
import hjb03 from './images/hjb_03.jpg';
import yjb01 from './images/yjb_01.jpg';
import yjb02 from './images/yjb_02.jpg';
import axk01 from './images/axk_01.jpg';
import axk02 from './images/axk_02.jpg';
import qxb01 from './images/qxb_01.jpg';
import qxb02 from './images/qxb_02.jpg';
import dsk01 from './images/dsk_01.jpg';
import dsk02 from './images/dsk_02.jpg';

function Reports() {
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        const ww = document.documentElement.clientWidth;
        document.documentElement.style.fontSize = ww / 7.5 + 'px';

        const handleResize = () => {
            const newWw = document.documentElement.clientWidth;
            document.documentElement.style.fontSize = newWw / 7.5 + 'px';
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const tabs = [
        { id: 'c1', label: '黑金帮', images: [hjb01, hjb02, hjb03] },
        { id: 'c2', label: '一级帮', images: [yjb01, yjb02] },
        { id: 'c3', label: '安睡系列', images: [axk01, axk02] },
        { id: 'c4', label: '清新帮', images: [qxb01, qxb02] },
        { id: 'c5', label: '袋鼠裤', images: [dsk01, dsk02] }
    ];

    const handleTabClick = (index) => {
        document.documentElement.scrollTop = 0;
        setActiveTab(index);
    };

    return (
        <>
            <div className="nav" role="tablist" aria-label="产品系列">
                {tabs.map((tab, index) => (
                    <button
                        type="button"
                        key={tab.id}
                        id={`tab-${tab.id}`}
                        role="tab"
                        aria-selected={activeTab === index}
                        aria-controls={tab.id}
                        className={`nav-item ${activeTab === index ? 'active' : ''}`}
                        onClick={() => handleTabClick(index)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div className="wrapper">
                {tabs.map((tab, index) => (
                    <div
                        key={tab.id}
                        id={tab.id}
                        role="tabpanel"
                        aria-labelledby={`tab-${tab.id}`}
                        hidden={activeTab !== index}
                        className={`tab-content ${activeTab === index ? 'active' : ''}`}
                    >
                        <img src={banner} className="img-block" alt="banner" />
                        {tab.images.map((img, imgIndex) => (
                            <img
                                key={imgIndex}
                                src={img}
                                className="img-block"
                                alt={tab.label}
                            />
                        ))}
                    </div>
                ))}
            </div>
        </>
    );
}

export default Reports;
